import { Button, Container } from "react-bootstrap";

export default function PageStyles() {
  return (
    <div className="page-styles">
      <Container>
        <section>
          <h1>Heading 1</h1>
          <h2>Heading 2</h2>
          <h3>Heading 3</h3>
          <p>
            Styles are a collection of{" "}
            <a href="https://google.com">components that define</a> the look and
            feel of the application. They are used to create a consistent user{" "}
            <a href="https://google.com" className="alt">
              experience across
            </a>{" "}
            the entire application.
          </p>
          <Button variant="primary">Primary Button</Button>
          <br />
          <br />
          <Button variant="secondary">Secondary Button</Button>
          <br />
          <br />
          <br />
          <br />
          <h2>Logo Test: Current, 1pt, 2pt</h2>
          <br />
          <br />
          {["90", "110", "150", "180", "210"].map((h, i) => (
            <div
              key={h}
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "2rem",
                marginBottom: "2rem",
              }}
            >
              <div>size: {i + 1}</div>
              <img src="/images/logo-0pt.svg" alt="Logo" height={h} />
              <img src="/images/logo-1pt.svg" alt="Logo" height={h} />
              <img src="/images/logo-2pt.svg" alt="Logo" height={h} />
            </div>
          ))}
        </section>
      </Container>
      <section className="dark-theme">
        <Container>
          <h1>Heading 1</h1>
          <h2>Heading 2</h2>
          <h3>Heading 3</h3>
          <p>
            Styles are a collection of{" "}
            <a href="https://google.com">components that define</a> the look and
            feel of the application. They are used to create a consistent user{" "}
            <a href="https://google.com" className="alt">
              experience across
            </a>{" "}
            the entire application.
          </p>
          <Button variant="primary">Primary Button</Button>
          <br />
          <br />
          <Button variant="secondary">Secondary Button</Button>

          <h1>Logo in Different Sizes</h1>
          <br />
          <br />
          <img src="/images/logo-stacked.svg" alt="Logo" height="50" />
          <br />
          <br />
          <br />
          <img src="/images/logo-stacked.svg" alt="Logo" height="60" />
          <br />
          <br />
          <br />
          <img src="/images/logo-stacked.svg" alt="Logo" height="150" />
          <br />
          <br />
          <br />
          <br />
          <center>
            <img
              src="/images/logo.svg"
              alt="Logo"
              height="100"
              style={{ maxWidth: "100%" }}
            />
            <br />
            <br />
            <br />
            <img
              src="/images/logo.svg"
              alt="Logo"
              height="300"
              style={{ maxWidth: "100%" }}
            />
          </center>
        </Container>
      </section>
    </div>
  );
}
